import React from "react";
import { Prompt } from "react-router-dom";
import { Text } from "@foris/avocado-suite";
import { useTranslation } from "react-i18next";
import Modal from "@components/modal";

interface InstructorCorrectionGuardProps {
  active: boolean;
  showWarning: boolean;
  onBlocked: () => void;
  onCloseWarning: () => void;
}

const InstructorCorrectionGuard: React.FC<InstructorCorrectionGuardProps> = ({
  active,
  showWarning,
  onBlocked,
  onCloseWarning,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Prompt
        when={active}
        message={() => {
          onBlocked();
          return false;
        }}
      />
      <Modal
        typeState="warning"
        title={t("bundle.instructor-correction.departure-title")}
        show={showWarning}
        textButtonPrincipal={t("bundle.instructor-correction.continue-action")}
        onClickPrincipal={onCloseWarning}
      >
        <Text>{t("bundle.instructor-correction.departure-message")}</Text>
      </Modal>
    </>
  );
};

export default InstructorCorrectionGuard;
